import {CustomMustache} from 'app/utils/template/customMustache';

export const baseTemplateMethods = {
    spaceAfterComma: () => {
        return (text: string, render: (value: string) => string) => {
            return render(text).replace(/,/g, ', ');
        };
    },
    base64: () => {
        return (text: string, render: (value: string) => string) => {
            return window.btoa(render(text));
        };
    },
};

export function template(templateInput: string, values: Record<string, any>, tags?: [string, string]): string {
    return CustomMustache.render(templateInput, {...values, ...baseTemplateMethods}, {}, tags);
}
